import {createSlice, PayloadAction} from '@reduxjs/toolkit';

interface IHighLevelProductionState {
  chartData: {
    productionSets: number;
    firstBates: string;
    lastBates: string;
    imageCount: number;
    nativeCount: number;
  };
}

const initialState: IHighLevelProductionState = {
  chartData: {
    productionSets: 0,
    firstBates: '',
    lastBates: '',
    imageCount: 0,
    nativeCount: 0,
  },
};

const highLevelProductionSlice = createSlice({
  name: 'highLevelProductionMetric',
  initialState,
  reducers: {
    setChartData: (state, action: PayloadAction<any>) => {
      state.chartData = action.payload;
    },
  },
});

export const {setChartData} = highLevelProductionSlice.actions;
export default highLevelProductionSlice.reducer;
